import React from 'react';
import PropTypes from 'prop-types';
import Divider from "@material-ui/core/Divider";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { OpenInNew } from '@material-ui/icons';
import TextOnlyFormField from "../TextOnlyFormField/TextOnlyFormField";
import AutoComplete from "../AutoComplete";

const SketchOrderCardCustomerInformation = props => {
    const openOwnerInSupportDashboard = () => {
        window.open(`${process.env.REACT_APP_SUPPORT_DASHBOARD_HOST}userprofiles/${props.sketchOrder.owner.userId}/show`)
    };

    return (
        (
            props.showOrganizationName ||
            props.showOwner ||
            props.showRequester
        ) &&
        <div>
            <Divider />
            <CardContent>
                <Typography variant="h6" gutterBottom>
                    Customer Information
                </Typography>

                {
                    (props.showOrganizationName && props.sketchOrder.organization) &&
                    <div>
                        {
                            (props.showLinksToSupportDashboard && process.env.REACT_APP_ENVIRONMENT.endsWith('production')) ? (
                                <TextOnlyFormField
                                    label="Organization"
                                    value={props.sketchOrder.organization.name}
                                    link={`${process.env.REACT_APP_SUPPORT_DASHBOARD_HOST}organizations/${props.sketchOrder.organization.id}/show`}
                                />
                            ) : (
                                <TextOnlyFormField
                                    label="Organization"
                                    value={props.sketchOrder.organization.name}
                                />
                            )
                        }
                    </div>
                }
                {
                    (props.showRequester && props.sketchOrder.requester) &&
                    <div>
                        {
                            (props.showLinksToSupportDashboard && process.env.REACT_APP_ENVIRONMENT.endsWith('production')) ? (
                                <TextOnlyFormField
                                    label="Requester"
                                    value={props.sketchOrder.requester.userName}
                                    link={`${process.env.REACT_APP_SUPPORT_DASHBOARD_HOST}userProfiles/${props.sketchOrder.requester.userId}/show`}
                                />
                            ) : (
                                <TextOnlyFormField
                                    label="Requester"
                                    value={props.sketchOrder.requester.userName}
                                />
                            )
                        }
                    </div>
                }
                {
                    (props.showOwner && props.sketchOrder.owner) &&
                    <Grid container>
                        <Grid item xs={(props.showLinksToSupportDashboard && process.env.REACT_APP_ENVIRONMENT.endsWith('production')) ? 11 : 12}>
                            <AutoComplete
                                onChange={props.onOwnerChange}
                                value={props.sketchOrder.owner}
                                labelProp="userName"
                                valueProp="userId"
                                options={props.organizationsUsers}
                                label="Owner - Email"
                                onSearch={props.onSearchUsers}
                                readOnly={!props.canEditOwner}
                            />
                        </Grid>
                        {
                            (props.showLinksToSupportDashboard && process.env.REACT_APP_ENVIRONMENT.endsWith('production')) &&
                            <Grid item xs={1}>
                                <Tooltip title="Open In Support Dashboard">
                                    <IconButton onClick={openOwnerInSupportDashboard} disabled={!props.sketchOrder.owner.userId}>
                                        <OpenInNew />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                        }
                    </Grid>
                }
            </CardContent>
        </div>
    );
};

SketchOrderCardCustomerInformation.propTypes = {
    sketchOrder: PropTypes.shape({
        organization: PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
        }),
        requester: PropTypes.shape({
            userName: PropTypes.string,
            userId: PropTypes.number
        }),
        owner: PropTypes.shape({
            userName: PropTypes.string,
            userId: PropTypes.number
        })
    }).isRequired,
    showOrganizationName: PropTypes.bool,
    showOwner: PropTypes.bool,
    showRequester: PropTypes.bool,
    showLinksToSupportDashboard: PropTypes.bool,
    canEditOwner: PropTypes.bool,
    onOwnerChange: PropTypes.func.isRequired,
    organizationsUsers: PropTypes.arrayOf(PropTypes.shape({
        userId: PropTypes.number,
        userName: PropTypes.string,
    })),
    onSearchUsers: PropTypes.func.isRequired,
};

SketchOrderCardCustomerInformation.defaultProps = {
    showLinksToSupportDashboard: false,
    canEditOwner: false,
    organizationsUsers: []
};

export default SketchOrderCardCustomerInformation;
